import axios from 'axios';

const UserService = {
  async getMe() {
    const response = await axios.get('/users/me');

    return response.data;
  },

  async toggleUserEnabledStatus(userId) {
    const response = await axios.post(`/users/${userId}/toggle-enabled`);

    return response.data;
  },

  async createUser(formValues) {
    const response = await axios.post('/users', formValues);

    return response.data;
  },

  async changePassword(password) {
    const response = await axios.post('/users/me/change-password', password);

    return response.data;
  },

  async getUsers({ role, brokerIds }) {
    const response = await axios.get('/users', {
      params: { role, brokerIds },
    });

    return response.data;
  },
};

export default UserService;
